import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { ApiKey } from '@/types/apiKey';

interface RevokeApiKeyModalProps {
  apiKey: ApiKey | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function RevokeApiKeyModal({ apiKey, onOpenChange, onConfirm }: RevokeApiKeyModalProps) {
  useLanguage();
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <AlertDialog open={!!apiKey} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-[440px] rounded-xl p-6">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-lg font-semibold text-foreground">
            {translateInterfaceText("Revogar \"")}{apiKey?.name}"?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-muted-foreground mt-1.5">
            {translateInterfaceText("Qualquer ferramenta que estiver usando esta chave perde o acesso na hora, e não há como reativá-la. Suas outras chaves continuam funcionando.")}</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="mt-4 flex justify-end gap-2">
          <AlertDialogCancel className="h-10 px-4 rounded-[10px] border-border text-muted-foreground hover:bg-muted hover:text-[#1E293B] transition-colors">
            {translateInterfaceText("Cancelar")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="h-10 px-4 rounded-[10px] bg-red-600 hover:bg-red-700 text-white font-semibold transition-colors"
          >
            {translateInterfaceText("Revogar")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
